import { useCustomMutation } from "@/shared/hooks/useCustomMutation";
import { useQueryClient } from "@tanstack/react-query";
import LearningService from "../service/learningService";

export function useLearningMutations() {
    const queryClient = useQueryClient();

    const associateCategory = useCustomMutation({
        serviceInstance: LearningService.Instance,
        selectAction: (s) => s.associateCategory,
    });

    const removeCategory = useCustomMutation({
        serviceInstance: LearningService.Instance,
        selectAction: (s) => s.removeCategory,
    });

    const createMutation = useCustomMutation({
        serviceInstance: LearningService.Instance,
        selectAction: (s) => s.createLearning,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["get-learnings"] });
        },
    });

    const updateMutation = useCustomMutation({
        serviceInstance: LearningService.Instance,
        selectAction: (s) => s.updateLearning,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["get-learnings"] });
        },
    });

    const deleteMutation = useCustomMutation({
        serviceInstance: LearningService.Instance,
        selectAction: (s) => s.removeLearning,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["get-learnings"] });
        },
    });

    return {
        createMutation,
        updateMutation,
        deleteMutation,
        associateCategory,
        removeCategory
    };
}
